var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewEdit)?_c('design',{attrs:{"app":_vm.app}}):_vm._e(),(!_vm.viewEdit)?_c('preview',{attrs:{"app":_vm.app}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }